import { arrayOf, bool, number, objectOf, oneOfType, string } from "prop-types";

export const I18nShape = objectOf(
  oneOfType([string, number, bool, arrayOf(string)])
);

export default I18nShape;
